module.exports = __webpack_public_path__ + "static/media/home2.06aa36f5.png";